export const SET_INSTITUTION_COMPLETION_DATA =
  'SET_INSTITUTION_COMPLETION_DATA';
export const UPDATE_SELECTED_INSTITUTION_COMPLETION_COURSE_LIST =
  'UPDATE_SELECTED_INSTITUTION_COMPLETION_COURSE_LIST';
export const START_LOADING_INSTITUTION_COMPLETION_DATA =
  'START_LOADING_INSTITUTION_COMPLETION_DATA';
export const FINISH_LOADING_INSTITUTION_COMPLETION_DATA =
  'FINISH_LOADING_INSTITUTION_COMPLETION_DATA';
export const SET_USER_SELECTED_DATA = 'SET_USER_SELECTED_DATA';
export const START_LOADING_CSV_DATA = 'START_LOADING_CSV_DATA';
export const INTERMEDIATE_LOADING_CSV_DATA =
  'INTERMEDIATE_LOADING_LOADING_CSV_DATA';
export const FINISH_LOADING_CSV_DATA = 'FINISH_LOADING_CSV_DATA';
